import css3 from './css3.svg'
import html from './html.svg'
import javascript from './javascript.svg'
import reactGrey from './reactGrey.svg'

const Tools = () => {
  return (
    <div>
        <h2 className='tools-heading'>Tools of my trade:</h2>
        <div className="tools">
            <div className='grid-item'>
                <img src={css3} alt="css3"/>
                <p>CSS</p>
            </div>
            <div className='grid-item'>
                <img src={html} alt="html" />
                <p>HTML</p>
            </div>
            <div className='grid-item'>
                <img src={javascript} alt="javascript" />
                <p>Javascript</p>
            </div>
            <div className='grid-item'>
                <img src={reactGrey} alt="react" />
                <p>React</p>
            </div>
        </div>
    </div>
  )
}

export default Tools